import { Injectable } from '@angular/core';
import * as english from '../languages/language.en';
import * as swedish from '../languages/language.se';
import * as finnish from '../languages/language.fi';
import * as danish from '../languages/language.dk';
import { BehaviorSubject } from 'rxjs';
import { Database, get, ref } from '@angular/fire/database';
import { inject } from '@angular/core';

@Injectable({
    providedIn: "root"
})
export class LanguageService {
    private database = inject(Database);

    availableLanguages = [
        { lang: "Svenska", code: "se" },
        { lang: "English", code: "en" },
        { lang: "Suomi", code: "fi" },
        { lang: "Dansk", code: "dk" }];

    currentLanguage: string;
    currentLanguageSubject: BehaviorSubject<string>;

    constructor() {
        this.currentLanguage = "en";
        this.currentLanguageSubject = new BehaviorSubject(this.currentLanguage);
    }
    getAvailableLanguages() {
        return this.availableLanguages;
    }
    setLanguage(languageCode: string) {
        this.currentLanguage = languageCode;
        this.currentLanguageSubject.next(this.currentLanguage);
    }

    async initializeDefaultLanguage(routeName: string): Promise<void> {
        try {
            const defaultLanguagePath = `/Clients/${routeName}/AppInfo/Context/defaultLanguage`;
            const snapshot = await get(ref(this.database, defaultLanguagePath));
            const defaultLanguage = snapshot.val();
            const isSupported = this.availableLanguages.some(lang => lang.code === defaultLanguage);
            this.setLanguage(isSupported ? defaultLanguage : 'en');
        } catch {
            this.setLanguage('en');
        }
    }
    getString(translationProperty: string, languageCode?: string, parameters?: string[]) {
        if (!languageCode)
            languageCode = this.currentLanguage;
        switch (languageCode) {
            case "se": {
                if (parameters) return swedish.lang.get(translationProperty, parameters);
                else return swedish.lang[translationProperty]
            }
            case "fi": {
                if (parameters) return finnish.lang.get(translationProperty, parameters);
                else return finnish.lang[translationProperty]
            }
            case "en": {
                if (parameters) return english.lang.get(translationProperty, parameters);
                else return english.lang[translationProperty]
            }
            case "dk": {
                if (parameters) return danish.lang.get(translationProperty, parameters);
                else return danish.lang[translationProperty]
            }
        }
    }
}
